module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-541.5a7a1e3.woff2";